import { richTextResolver } from "@website-builder/utilities-index";

export default (
	{
		headerName,
		accordionItems = [],
		headerAlignment,
		headerSize,
		subHeading = "",
		activeStateColor,
		inactiveStateColor,
	},
	{ globalVariableWithURL = [] },
) => {
	accordionItems = accordionItems.map((item) => {
		item.contentInHtml = richTextResolver(item.content, globalVariableWithURL);
		return item;
	});
	return {
		headerName,
		accordionItems,
		headerAlignment,
		headerSize: headerSize,
		accordionItems,
		subHeading,
		activeStateColor: activeStateColor?.color,
		inactiveStateColor: inactiveStateColor?.color,
	};
};
